exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-resource[data-v-3cf2119a]{min-width:375px;max-width:375px;min-height:auto;max-height:400px\n}\n.card-body[data-v-3cf2119a]{min-height:auto;min-width:auto;padding:0\n}\n.card-body .card-icon[data-v-3cf2119a]{cursor:pointer;justify-content:center\n}\n.card-body .card-b-img[data-v-3cf2119a]{cursor:pointer;width:100%;max-height:114px;object-fit:contain\n}\n.text-xsmall-bold[data-v-3cf2119a]{font-size:x-small;font-weight:bold\n}\n", ""]);

// exports
